// extracted by mini-css-extract-plugin
export default {"root":"cNot54","IndentedMenuButtonNSkin":"mcyv1E","indentedMenuButtonNSkin":"mcyv1E","linkElement":"ZA3o_7","extra":"Qf__pA","wrapper":"nvYKf2","label":"AFa7Ix","bg":"Qy4jXD"};